import { render, staticRenderFns } from "./createQuote.vue?vue&type=template&id=56193a1c&scoped=true&"
import script from "./createQuote.vue?vue&type=script&lang=js&"
export * from "./createQuote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56193a1c",
  null
  
)

export default component.exports